export default "__VITE_ASSET__CDwxlzrE__"